import { eventMutators } from './event/mutators'
import { repositoryMutators } from './repository/mutators'
import { teamMutators } from './team/mutators'
import { bookmarkMutators } from './bookmark/mutators'
import { notificationMutators } from './notification/mutators'

export type TeamSpaceMutators = typeof teamSpaceMutators

export const teamSpaceMutators = {
  ...teamMutators,
  ...repositoryMutators,
  ...eventMutators,
  ...bookmarkMutators,
  ...notificationMutators,
}
